exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-close[data-v-aa3ae730]{position:absolute;right:25px;top:21px}button[data-v-aa3ae730]{text-transform:uppercase;font-size:11px;font-weight:600;color:#fff;border:1px solid #fff;padding:5px 10px;margin-top:20px;letter-spacing:1px;cursor:pointer}.error-wrapper p[data-v-aa3ae730]{margin:0;padding:0 50px}.fadeinup-enter-active[data-v-aa3ae730],.fadeinup-leave-active[data-v-aa3ae730]{-webkit-transition:.3s ease-in-out;transition:.3s ease-in-out}.fadeinup-enter[data-v-aa3ae730],.fadeinup-leave-active[data-v-aa3ae730]{opacity:0;-webkit-transform:translateY(8px);transform:translateY(8px)}.details[data-v-aa3ae730]{width:600px;margin:0 auto;font-family:monospace;font-size:.75rem;line-height:1.4rem;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa3ae730","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/layout/Error.vue
// module id = rpvX
// module chunks = 0 1